import React from 'react'
import { Link } from 'react-router-dom'
import { recipesRetiredCopy } from '../../features/recipe-upgrades/retired-copy'

export const RecipesRetiredNotice = () => (
    <div
        className="m-4 flex items-center gap-[14px] rounded-lg border border-[#E5E7EB] bg-white px-[18px] py-4 shadow-[0_1px_2px_rgba(17,20,24,.04)]"
        data-testid="recipes-retired-notice"
    >
        <div className="flex-1 text-[14px] leading-[21px] text-[#1C2127]">
            <div className="font-semibold tracking-[-0.005em]">
                {recipesRetiredCopy.noticeTitle}
            </div>
            <div>{recipesRetiredCopy.noticeBody}</div>
        </div>
        <div className="flex shrink-0 items-center gap-2">
            <Link
                className="inline-flex h-[30px] items-center rounded-lg px-[10px] py-[5px] text-[14px] leading-5 text-[#215db0]"
                to="/segments"
            >
                {recipesRetiredCopy.goToSegments}
            </Link>
            <Link
                className="inline-flex h-[30px] items-center rounded-lg bg-[#2d72d2] px-3 py-[5px] text-[14px] leading-5 text-white shadow-[0_2px_4px_rgba(0,0,0,.075)]"
                to="/segments/new"
            >
                {recipesRetiredCopy.createSegment}
            </Link>
        </div>
    </div>
)
